<template lang="html">
  <div class="row no-margin track" style="width: 500px; height: 400px">
    <div v-if="true">
      <iframe :src="this.order.flow.app_tracking.embed_url" frameborder="0"
          style="border:0" width="770px" height="700px" title="HyperTrack"/>
    </div>
    <!-- <div v-if="!trackingEnabled && hasDriverAccepted"
      class="track-map" style="width: 100%; height: 100%">
      <GmapMap ref="mapRef" map-type-id="terrain"
        :center="center"
        :zoom="4"
        style="width: 100%; height: 100%">
      <GmapMarker
        v-if="markers.length>0"
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :icon="m.icon"
        :clickable="true"
        @click="toggleInfoWindow(m,index)" />

        <GmapPolyline v-if="paths.length > 0"
            :path="paths"
            :options="currentPathPolyline"
            ref="polyline" />

        <GmapMarker
          v-if="paths.length>0"
          :key="index"
          v-for="(m, index) in travelPath"
          :position="{lat: m.lat, lng: m.lng}"
          :icon="m.icon"
          :clickable="true"
          @click="toggleInfoWindow(m,index)" />

        <GmapInfoWindow
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen=false" >
          <span v-html="infoContent"> </span>
        </GmapInfoWindow>
      </GmapMap>
    </div> -->
  </div>
</template>
<script>
// import TruckIcon from '@common/asset/images/truck.svg';
// import SourceIcon from '@common/asset/images/source.svg';
// import DestinationIcon from '@common/asset/images/destination.svg';
// import DotIcon from '@common/asset/images/dot.svg';

export default {

  props: {
    order: {
      type: Object,
      default: () => {},
    },
    hasDriverAccepted: {
      type: Boolean,
      default: false,
    },
    trackingEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
        GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
    // currentConsignee: null,
    //   TruckIcon,
    //   SourceIcon,
    //   DestinationIcon,
    //   DotIcon,
    //   consigneesMap: {},
    //   center: {

    //   },
    //   markers: [],
    //   travelPath: [],
    //   hyperTrackData: [],
    //   paths: [],
    //   currentPlace: null,
    //   isMapLoading: false,
    //   infoContent: '',
    //   infoWindowPos: null,
    //   infoWinOpen: false,
    //   infoOptions: {
    //     pixelOffset: {
    //       width: 0,
    //       height: -25,
    //     },
    //   },
    //   currentPathPolyline: {
    //     strokeColor: '#008AFF',
    //     strokeWeight: 2,
    //     zIndex: 10,
    //   },
    //   currentMidx: null,
    };
  },

  async created() {
    //const orderNo = this.order.order_number;
    /* eslint-disable no-param-reassign */
    // this.consigneesMap = this.order.consignees.reduce((consigneeObj, _consignee) => {
    //   consigneeObj[_consignee.id] = _consignee;
    //   return consigneeObj;
    // }, {});
    // await this.$emit('getLocations', orderNo);
    // const { data } = await this.$store.dispatch('order/appLocation', orderNo);
    // if (this.hyperTrackData) {
    //   let paths = [];
    //   if (hyperTrackData.locations) {
    //     paths = this.hyperTrackData.locations.map(_location => ({
    //       lat: _location.lat,
    //       lng: _location.lon,
    //       position: {
    //         lat: _location.lat,
    //         lng: _location.lon,
    //       },
    //       locationDetails: {
    //         haltTime: _location.haltTime,
    //         battery: _location.battery,
    //       },
    //       icon: `${this.DotIcon}`,
    //       created_at: new Date(_location.createdAt),

    //     }));
    //   }


    //   const locations = this.hyperTrackData.sources.reduce((locationArr, _source) => {
    //     const depot = this.$depot.depotOthers(_source.srcId);
    //     locationArr.push({
    //       position: {
    //         lat: _source.lat,
    //         lng: _source.lon,
    //       },
    //       icon: `${this.SourceIcon}`,
    //       details: {
    //         label: 'Depot',
    //         name: depot.name || '',
    //         reference_id: depot.reference_id || '',
    //       },
    //     });
    //     return locationArr;
    //   }, []);

    //   this.paths = paths;
    //   this.center = paths[0] || locations[0].position;
    //   this.travelPath = [...paths];
    //   if (this.travelPath.length > 1) {
    //     this.travelPath.shift();
    //   }
    //   if (paths[0]) {
    //     locations.push({
    //       position: paths[0],
    //       icon: `${this.TruckIcon}`,
    //       created_at: new Date(paths[0].created_at),
    //       driver_number: this.hyperTrackData.driverPhone,
    //     });
    //   }

    //   const alllocation = this.hyperTrackData.destinations.reduce((locationArr, _destination) => {
    //     const consigneeId = _destination.destId.split(':');
    //     locationArr.push({
    //       position: {
    //         lat: _destination.lat,
    //         lng: _destination.lon,
    //       },
    //       icon: `${this.DestinationIcon}`,
    //       details: {
    //         label: 'Consignee',
    //         name: this.consigneesMap[consigneeId[0]] ? this.consigneesMap[consigneeId[0]].name : '',
    //         reference_id: this.consigneesMap[consigneeId[0]] ?
    //           this.consigneesMap[consigneeId[0]].reference_id : '',
    //       },
    //     });
    //     return locations;
    //   }, locations);

    //   this.markers = alllocation;
    // }
  },

  methods: {
    getConsigneeName(id) {
      return this.order.consignees.find(consignee => consignee.id === id);
    },

    setCurrentConsignee(consignee) {
      this.currentConsignee = consignee;
    },

    dateFormat(date) {
      return `${date.toDateString()} ${date.toLocaleTimeString()}`;
    },

    msToTime(duration) {
      const milliseconds = parseInt((duration % 1000) / 100);
      let seconds = Math.floor((duration / 1000) % 60);
      let minutes = Math.floor((duration / (1000 * 60)) % 60);
      let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

      hours = (hours < 10) ? `0${hours}` : hours;
      minutes = (minutes < 10) ? `0${minutes}` : minutes;
      seconds = (seconds < 10) ? `0${seconds}` : seconds;

      return `${hours}hr :${minutes} min :${seconds}.${milliseconds}`;
    },

    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '';
      if (marker.driver_number) {
        const lastSeen = new Date(marker.created_at);
        this.infoContent = `<b>Truck no:</b> ${this.order.vehicle.number} <br/> <b>Driver Number:</b> ${marker.driver_number}<br/>  <b>Last seen:</b> ${this.dateFormat(lastSeen)}`;
      }

      if (marker.details) {
        this.infoContent = `<b>${marker.details.label}:</b> ${marker.details.name} <br/> <b>Reference Numner:</b> ${marker.details.reference_id}<br/>`;
      }

      if (marker.locationDetails) {
        this.infoContent = `<b>Battery:</b> ${marker.locationDetails.battery}% <br/> <b>Halted For:</b> ${this.msToTime(marker.locationDetails.haltTime)}<br/>`;
      }


      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      this.center = marker.position;
    },

  },

};
</script>

<style lang="scss">
@import "~@common/styles-shipper/settings";
.track {
    //border: 1px solid #E8E8E8;
    &-map {
        display: inline-block;
        float: left;
        &-list {
            display: inline-block;
            ul {
                padding-left: 0;
                margin: 0;
                @extend %list-unstyled;
                li {
                    padding: 10px;
                    width: 140px;
                    border-bottom: 1px solid #E8E8E8;
                    text-align: left;
                    a {
                        font-size: 1.2rem;
                        color: #6E6E6E;
                        letter-spacing: 0.3px;
                        text-decoration: none;
                        &.active {
                            color: #008AFF;
                        }
                    }
                }
            }
        }
    }
}
</style>
